// Full-document render of the password-reset "done" view: the sealy
// AccountShell wrapping the confirmation copy. The paragraphs are
// server-localized props; the "Email sent" heading was hardcoded English in
// the legacy template.
import React from "react";

import { templates } from "@reactivated";

import { AccountShell } from "../components/AccountShell";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetDoneDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
        >
            <h2>Email sent</h2>
            {props.paragraphs.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
            ))}
        </AccountShell>
    </PageSkeleton>
);
